export interface ActivationInput {
  password: string
  confirmPassword: string
  phoneNumber: string
}

export type ActivationErrors = Partial<Record<keyof ActivationInput, string>>

// Same limits as the Student Service, so the server never rejects what passed here.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const PHONE = /^\+?[0-9 ()-]{7,20}$/
export const PASSWORD_MIN = 8
export const PASSWORD_MAX = 72

/** The error for the email that asks for a set-up link, or undefined when it looks like an email. */
export function validateEmail(email: string): string | undefined {
  return EMAIL.test(email.trim()) ? undefined : 'Enter the email your college has on file.'
}

export function validateActivation(input: ActivationInput): ActivationErrors {
  const errors: ActivationErrors = {}
  if (input.password.length < PASSWORD_MIN) errors.password = `Use at least ${PASSWORD_MIN} characters.`
  else if (input.password.length > PASSWORD_MAX) errors.password = `Use at most ${PASSWORD_MAX} characters.`
  if (!errors.password && input.confirmPassword !== input.password) errors.confirmPassword = 'The passwords do not match.'
  if (!PHONE.test(input.phoneNumber.trim())) errors.phoneNumber = 'Enter a mobile number with 7 to 20 digits.'
  return errors
}
